// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-threeD-snapshots-SnapshotImage-module-snapshotImage {
    position: absolute !important;
}

.csi-threeD-snapshots-SnapshotImage-module-snapshotImage {
    right: 0;
    top: 0;
}

.csi-threeD-snapshots-SnapshotImage-module-snapshotTag {
    position: absolute !important;
}

.csi-threeD-snapshots-SnapshotImage-module-snapshotTag {
    bottom: 5px;
    left: 5px;
    max-width: 95%;
}`, "",{"version":3,"sources":["webpack://./src/csi/threeD/snapshots/SnapshotImage.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AAGjC;;AAJA;IAEI,QAAQ;IACR,MAAM;AACV;;AAEA;IAGI,6BAA6B;AAEjC;;AALA;IACI,WAAW;IACX,SAAS;IAET,cAAc;AAClB","sourcesContent":[".snapshotImage {\n    position: absolute !important;\n    right: 0;\n    top: 0;\n}\n\n.snapshotTag {\n    bottom: 5px;\n    left: 5px;\n    position: absolute !important;\n    max-width: 95%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"snapshotImage": `csi-threeD-snapshots-SnapshotImage-module-snapshotImage`,
	"snapshotTag": `csi-threeD-snapshots-SnapshotImage-module-snapshotTag`
};
module.exports = ___CSS_LOADER_EXPORT___;
